export default "__VITE_ASSET__LIJ2kyF2__"